module.exports = __webpack_public_path__ + "static/media/global.6869a974.png";